module.exports = __webpack_public_path__ + "img/symbol_8.f303ff6e.png";